module.exports = __webpack_public_path__ + "img/shu.46dbe64a.jpg";